var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForestryLandUse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.861 21.596",
    style: {
      color: "white"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_506",
    "data-name": "Groupe 506",
    transform: "translate(-180.89 -146.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_574",
    "data-name": "Trac\\xE9 574",
    d: "M92.107,84.226a6.534,6.534,0,1,1-8.808,0s-.074-.534-.074-.811a4.477,4.477,0,1,1,8.882.81Z",
    transform: "translate(104.068 68.286)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_575",
    "data-name": "Trac\\xE9 575",
    d: "M94.438,85.549a3.367,3.367,0,0,1,4.453,3.184,3.32,3.32,0,0,1-.055.606,4.767,4.767,0,1,1-6.358,7.1",
    transform: "translate(101.739 66.961)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_576",
    "data-name": "Trac\\xE9 576",
    d: "M82.3,85.549a3.367,3.367,0,0,0-4.454,3.184,3.41,3.41,0,0,0,.068.678,4.768,4.768,0,1,0,6.413,7.056",
    transform: "translate(105.067 66.961)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_156",
    "data-name": "Ligne 156",
    y2: 14.104,
    transform: "translate(191.798 153.704)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_157",
    "data-name": "Ligne 157",
    y2: 3.122,
    transform: "translate(197.483 164.697)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_158",
    "data-name": "Ligne 158",
    y2: 3.11,
    transform: "translate(186.157 164.697)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_159",
    "data-name": "Ligne 159",
    x1: 2.771,
    y1: 2.067,
    transform: "translate(189.013 157.485)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_160",
    "data-name": "Ligne 160",
    y1: 1.295,
    x2: 1.924,
    transform: "translate(191.784 155.621)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_161",
    "data-name": "Ligne 161",
    y1: 1.964,
    x2: 2.754,
    transform: "translate(191.798 159.552)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForestryLandUse);
export default __webpack_public_path__ + "static/media/forestry-land-use.bada52fde61add74f196ca33e7f73734.svg";
export { ForwardRef as ReactComponent };